import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';

import { RouterLink, ActivatedRoute } from '@angular/router';
import { NgIcon, provideIcons } from '@ng-icons/core';
import { lucideMail, lucideUsers } from '@ng-icons/lucide';
import { HlmAlertImports } from '@spartan-ng/helm/alert';
import { HlmButtonImports } from '@spartan-ng/helm/button';
import { HlmCardImports } from '@spartan-ng/helm/card';
import { HlmTypographyImports } from '@spartan-ng/helm/typography';
import { LogoComponent } from '../../components/logo/logo.component';

@Component({
  selector: 'app-register-success',
  imports: [
    RouterLink,
    NgIcon,
    HlmAlertImports,
    HlmButtonImports,
    HlmCardImports,
    HlmTypographyImports,
    LogoComponent,
  ],
  providers: [provideIcons({ lucideMail, lucideUsers })],
  templateUrl: './register-success.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
})
export class RegisterSuccessComponent implements OnInit {
  pendingGroupName: string | null = null;
  loginRedirect: string | null = null;

  constructor(private route: ActivatedRoute) {}

  ngOnInit(): void {
    this.loginRedirect = this.route.snapshot.queryParamMap.get('redirect');
    this.pendingGroupName = this.route.snapshot.queryParamMap.get('groupName');
  }
}
